export const navbar_profile_utils_methods = {
  is_data_descriptor(descriptor) {
    return Boolean(
      descriptor?.enumerable
      && !Reflect.has(descriptor, 'get')
      && !Reflect.has(descriptor, 'set')
    );
  },

  get_own_data_descriptor(obj, key) {
    const descriptor = Object.getOwnPropertyDescriptor(obj ?? {}, key);

    return this.is_data_descriptor(descriptor)
      ? descriptor
      : null;
  },

  coerce_to_safe_string(v) {
    const COERCERS = { string: (x) => x, number: String, boolean: String };
    const fn = COERCERS[typeof v];
    return fn ? fn(v) : '';
  },

  safe_own_string(obj, key) {
    const d = this.get_own_data_descriptor(obj, key);
    return d ? this.coerce_to_safe_string(d.value) : '';
  },

  normalize(v) {
    return (v ?? '').toString().trim();
  },

  normalized_diff(a, b) {
    return this.normalize(a) !== this.normalize(b);
  },

  core_user_changed() {
    return Boolean(this.original_user) && this.core_user_fields_changed();
  },

  core_user_fields_changed() {
    return this.normalized_diff(this.user.first_name, this.original_user.first_name)
      || this.normalized_diff(this.user.last_name, this.original_user.last_name)
      || this.normalized_diff((this.user.email || '').toLowerCase(), this.original_user.email);
  },

  company_changed() {
    if (!this.original_company) return true;

    return this.profile_fields_changed(
      this.new_company || {},
      this.original_company,
      ['company_name', 'registration_number', 'vat_number', 'phone_number', 'address']
    );
  },

  profile_changed() {
    if (!this.original_profile) return true;

    return this.profile_fields_changed(
      this.user_profile || {},
      this.original_profile,
      ['phone_number', 'address', 'id_number', 'province', 'country', 'gender']
    );
  },

  profile_fields_changed(now, orig, fields) {
    return fields.some(k =>
      this.normalized_diff(
        this.safe_own_string(now, k),
        this.safe_own_string(orig, k)
      )
    );
  },

  backend_error_message(err) {
    return Reflect.get(err, 'message')
      ?? Reflect.get(err, 'error')
      ?? Reflect.get(err, 'detail')
      ?? err;
  },

  parse_backend_error(err) {
    if (!err) return 'An unknown error occurred';
    if (typeof err === 'string') return err;

    return this.parse_backend_message(this.backend_error_message(err));
  },

  parse_backend_message(msg) {
    if (typeof msg === 'string') return msg;
    if (typeof msg !== 'object') return JSON.stringify(msg);

    return Reflect.ownKeys(msg)
      .map((key) => this.format_backend_error_field(key, Reflect.get(msg, key)))
      .join(' | ');
  },

  format_backend_error_field(key, value) {
    if (Array.isArray(value)) return `${String(key)}: ${value.join(', ')}`;
    if (typeof value === 'string') return `${String(key)}: ${value}`;
    return `${String(key)}: ${JSON.stringify(value)}`;
  },
};
